import { Observable } from 'rxjs';
import { ApiService, POST_USER_REFERRAL_PATH, PostUserReferralBody } from '@core-http';

export class ReferrerHttpService extends ApiService {
  setReferrer(referralToken: string): Observable<void> {
    const payload: PostUserReferralBody = {
      referralToken: referralToken,
      referralId: ''
    };

    return this.httpClient.post<void>(`${this.env.apiUrl}${POST_USER_REFERRAL_PATH}`, payload);
  }
}
